import { boot } from 'quasar/wrappers'
import { createI18n } from 'vue-i18n'
import messages from 'src/i18n'
import datetimeFormats from 'ui-common/base/i18n/dateTime'
import deepmerge from 'deepmerge'
import editorDE from 'ui-common/base/i18n/locales/de-de.yaml'

const i18n = createI18n({
  legacy: false,
  locale: 'de-de',
  datetimeFormats,
  messages
})
const mergeMessages = toMerge => {
  Object.entries(toMerge).forEach(([locale, messagesToMerge]) => {
    i18n.global.setLocaleMessage(locale, deepmerge(messages[locale] || {}, messagesToMerge))
  })
}

export default boot(async ({ app }) => {
  const editorDeMessages = editorDE
  mergeMessages({ 'de-de': editorDeMessages })

  app.use(i18n)
})

const globali18n = i18n.global

export { globali18n as i18n, mergeMessages }
